export default __webpack_public_path__ + "static/media/capture-stones.75ab1f67.md";